<template>
  <div>
    <i
      v-if="type == 'calendly' && !calendly"
      class="icon-calendar text-danger"
    ></i>
    <span v-if="calendly">
      <small v-if="calendly == ''" class="text-danger">
        <i v-if="workspace_email" class="icon-calendar mr-1"></i>
      </small>
      <small v-else class="text-success">
        {{ calendly }}
      </small>
    </span>
    <div v-if="stats !== undefined">
      <div
        v-for="(available_contacts, key) in stats[user_id].available_contacts"
        v-if="
          type == 'campaigns' &&
          stats[user_id].available_contacts !== undefined &&
          (target_id == 0 || target_id == stats[user_id].targets[key])
        "
      >
        <a
          target="_blank"
          :href="getCampaignSearch(stats[user_id].campaign_names[key])"
        >
          <span
            :class="
              getClassAvailable(
                available_contacts,
                stats[user_id].campaign_status[key],
                stats[user_id].quantity_per_day[key],
                stats[user_id].warning_apollo[key]
              )
            "
            class="badge rounded text-white"
          >
            {{ stats[user_id].campaign_names[key] }}
            <i class="icon-checkmark ml-1" title="available contacts"></i>
            {{ available_contacts }}
            <i class="icon-user-plus ml-1" title="new contacts per day"></i>
            {{ stats[user_id].quantity_per_day[key] }}

            <span v-if="false">
              <i class="icon-search ml-1" title="visible contacts"></i>
              {{ stats[user_id].visible_contacts[key] }}
            </span>

            <span v-if="stats[user_id].new_emails_sent_today">
              <i class="icon-email ml-1" title="new engaged today"></i>
              {{ stats[user_id].new_emails_sent_today[key] }}
            </span>

            <span v-if="stats[user_id].recurring_emails_sent_today">
              <i class="icon-refresh ml-1" title="follow ups today"></i>
              {{ stats[user_id].recurring_emails_sent_today[key] }}
            </span>

            <span v-if="stats[user_id].emails_sent_b">
              <i class="icon-user ml-1" title="total contacts"></i>
              {{ stats[user_id].emails_sent_b }}
            </span>
          </span>
        </a>
      </div>

      <span class="" v-if="type == 'deliverability'"
        >{{
          getPercentage(stats[user_id].bounce_total, stats[user_id].emails_sent)
        }}
        %
        <div>
          <div
            v-if="
              calcKPI(
                getPercentage(
                  stats[user_id].bounce_total_7,
                  stats[user_id].emails_sent_7
                ),
                getPercentage(
                  stats[user_id].bounce_total_15,
                  stats[user_id].emails_sent_15
                )
              ) != 0
            "
            :class="
              getColorKPI(
                calcKPI(
                  getPercentage(
                    stats[user_id].bounce_total_7,
                    stats[user_id].emails_sent_7
                  ),
                  getPercentage(
                    stats[user_id].bounce_total_15,
                    stats[user_id].emails_sent_15
                  )
                ),
                true
              )
            "
          >
            {{
              calcKPI(
                getPercentage(
                  stats[user_id].bounce_total_7,
                  stats[user_id].emails_sent_7
                ),
                getPercentage(
                  stats[user_id].bounce_total_15,
                  stats[user_id].emails_sent_15
                )
              )
            }}%
          </div>
        </div>
      </span>

      <span v-if="type == 'statsnow'">
        <i class="icon-send text-success"></i>{{ stats[user_id].emails_sent }},
        <i class="icon-close text-danger"></i>{{ stats[user_id].bounce_total }},
        <i class="icon-eye text-primary"></i>{{ stats[user_id].emails_opened }}
      </span>

      <span class="" v-if="type == 'emailsopen'"
        >{{
          getPercentage(
            stats[user_id].emails_opened,
            stats[user_id].emails_sent_b
          )
        }}%
        <div>
          <div
            v-if="
              calcKPI(
                getPercentage(
                  stats[user_id].emails_opened_7,
                  stats[user_id].emails_sent_b_7
                ),
                getPercentage(
                  stats[user_id].emails_opened_15,
                  stats[user_id].emails_sent_b_15
                )
              ) != 0
            "
            :class="
              getColorKPI(
                calcKPI(
                  getPercentage(
                    stats[user_id].emails_opened_7,
                    stats[user_id].emails_sent_b_7
                  ),
                  getPercentage(
                    stats[user_id].emails_opened_15,
                    stats[user_id].emails_sent_b_15
                  )
                )
              )
            "
          >
            {{
              calcKPI(
                getPercentage(
                  stats[user_id].emails_opened_7,
                  stats[user_id].emails_sent_b_7
                ),
                getPercentage(
                  stats[user_id].emails_opened_15,
                  stats[user_id].emails_sent_b_15
                )
              )
            }}%
          </div>
        </div>
      </span>

      <span class="" v-if="type == 'avday'">{{
        parseFloat(stats[user_id].avday).toFixed(2)
      }}</span>

      <span class="" v-if="type == 'events'"
        >{{
          getPercentage(stats[user_id].events, stats[user_id].emails_sent_b)
        }}%
        <div>
          <div
            v-if="
              calcKPI(
                getPercentage(
                  stats[user_id].events_7,
                  stats[user_id].emails_sent_b_7
                ),
                getPercentage(
                  stats[user_id].events_15,
                  stats[user_id].emails_sent_b_15
                )
              ) != 0
            "
            :class="
              getColorKPI(
                calcKPI(
                  getPercentage(
                    stats[user_id].events_7,
                    stats[user_id].emails_sent_b_7
                  ),
                  getPercentage(
                    stats[user_id].events_15,
                    stats[user_id].emails_sent_b_15
                  )
                )
              )
            "
          >
            {{
              calcKPI(
                getPercentage(
                  stats[user_id].events_7,
                  stats[user_id].emails_sent_b_7
                ),
                getPercentage(
                  stats[user_id].events_15,
                  stats[user_id].emails_sent_b_15
                )
              )
            }}%
          </div>
        </div>
      </span>

      <span v-if="type == 'valid'" class="text-success">{{
        stats[user_id].events_total - stats[user_id].absent - stats[user_id].canceled
      }}</span>

      <span
        v-if="type == 'absent' && stats[user_id].absent > 0"
        class="text-warning"
        >{{ stats[user_id].absent }}</span
      >
      <span
        v-if="type == 'canceled' && stats[user_id].canceled > 0"
        class="text-danger"
        >{{ stats[user_id].canceled }}</span
      >
        <span
        class=""
        :class="getSpamRateClass(stats[user_id].placement_score)"
        v-if="type == 'placement_score'"
      >
        {{ parseFloat(stats[user_id].placement_score).toFixed(2) }}%
      </span>

      <span
        class=""
        :class="getSpamRateClass(stats[user_id].spam_rate)"
        v-if="type == 'spam_rate'"
      >
        {{ parseFloat(stats[user_id].spam_rate).toFixed(2) }}%
        <div>
          <div
            v-if="
              calcKPI(
                parseFloat(stats[user_id].spam_rate).toFixed(2),
                parseFloat(stats[user_id].spam_rate_7).toFixed(2)
              ) != 0
            "
            :class="
              getColorKPI(
                calcKPI(
                  parseFloat(stats[user_id].spam_rate).toFixed(2),
                  parseFloat(stats[user_id].spam_rate_7).toFixed(2)
                ),
                true
              )
            "
          >
            {{
              calcKPI(
                parseFloat(stats[user_id].spam_rate).toFixed(2),
                parseFloat(stats[user_id].spam_rate_7).toFixed(2)
              )
            }}%
          </div>
        </div>
      </span>
      <span class="" v-if="type == 'answering_rate_max'">{{
        parseFloat(stats[user_id].answering_rate_max).toFixed(2)
      }}%</span>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { monitorService, usersService } from "@/_services";
export default {
  created() {
    if (this.type == "calendly") {
      this.getCalendly();
    }
  },
  props: {
    user_id: String,
    type: String,
    stats: {
      required: false
    },
    target_id: {
      required: false,
      default: 0,
    },
    workspace_email: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      result: Array,
      calendly: false,
    };
  },
  methods: {
    calcKPI(val1, val2) {
      return parseFloat(val1 - val2).toFixed(2);
    },
    getColorKPI(val, reverse) {
      if ((val > 0 && reverse) || (val < 0 && !reverse)) {
        return "badge btn-danger";
      }
      return "badge btn-success";
    },
    getCalendly() {
      usersService.getCalendly(this.user_id).then((result) => {
        this.calendly = result.name;
      });
    },
    getClassAvailable(cant, campaign_status_id, per_day, warning_apollo) {
      if (campaign_status_id == 3) {
          return "badge-danger";
      }
       if (campaign_status_id == 1) {
          return "badge-secondary";
      }
      if (per_day == 0) {
        return "badge-secondary";
      }
      if (warning_apollo) {
        return "badge-warning";
      }
      return "badge-success";
    },
    getSpamRateClass(spam_rate) {
      if (spam_rate === null) {
        return "d-none";
      }
      if (spam_rate > 60) {
        return "text-danger";
      }
    },
    getCampaignSearch(campaign_name) {
      return (
        '/campaigns/filter/{ "filters": { "type": "and", "sort": "", "dir": "", "predicates": [ { "id": 1637054526, "name": "and", "type": "and", "label": "and", "field": "and", "list": "", "value": "", "comparison": "", "onHover": false, "canCreateGroup": false, "canAddFilter": false, "predicates": [ { "id": 1637054526, "name": "Campaign Name", "type": "string", "field": "campaign.name", "label": "Countains", "value": "' +
        campaign_name +
        '", "comparison": "contains", "onHover": false, "canCreateGroup": false, "canAddFilter": false, "predicates": [] } ] } ] }, "oldQuery": " (contains)' +
        campaign_name +
        ' " }'
      );
    },
    getClassSent(num, per_day, available_contacts) {
      if (per_day == 0) {
        return "badge-secondary";
      }
      if (num == "danger" && available_contacts == 0) {
        return "badge-secondary";
      }

      return "badge-" + num;
    },
    getPercentage(cant, total) {
      if (total == 0 || cant == 0) {
        return 0;
      }

      var result = (cant * 100) / total;
      result = parseFloat(result).toFixed(2);
      return result;
    },
  },
};
</script>
